module.exports = _IndicoReactI18n;